module.exports = __webpack_public_path__ + "img/arrow-bottom.186b8e1a.svg";